export default "__VITE_ASSET__abee30dd__"